const apiUrl = process.env.REACT_APP_API_URL;
export const PostActivitat = async (page: string, activitat: any) => {
    try {
        const response = await fetch(`${apiUrl}:8073/activitats`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(activitat)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            console.log(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
